module.exports = __webpack_public_path__ + "img/bg (5).6c7837ca.jpg";